module.exports = __webpack_public_path__ + "img/check.8ca64935.svg";